import React from 'react';
import {Background, SignInCardContainer} from './sign_in_page_styles';
import SignIn from "../../components/sign_in";
import {Routes} from "../../components/constants";
import SignUp from "../../components/sign_up";

function SignInPage(props) {
    return <Background>
        <SignInCardContainer>
            {props.createAccount ? <SignUp
                onNewAccount={() => props.history.push(Routes.signup)}
                onSignedUp={() => props.history.replace(Routes.accountCreated)} {...props}
                {...props}
            /> : <SignIn
                onSignedIn={() => props.history.replace(Routes.myStories)} {...props}
                onNewAccount={() => props.history.push(Routes.signup)}
            />}
        </SignInCardContainer>
    </Background>;
}

export default SignInPage;